/**
 * Base para carregar os pedacos (chunks) do bundle EM TEMPO DE EXECUCAO.
 *
 * POR QUE EXISTE. O build do app usa `PUBLIC_URL=.` — caminhos relativos, que
 * e o unico jeito de o `index.html` achar os assets dentro do pacote nativo
 * (`capacitor://localhost`). O efeito colateral e que o webpack passa a montar
 * a URL de cada chunk RELATIVA A ROTA ATUAL:
 *
 *   estando em /ajuda        -> ./static/js/842.chunk.js  = /static/js/...   OK
 *   estando em /ajuda/video-1 -> ./static/js/842.chunk.js = /ajuda/static/... 404
 *
 * Ou seja: toda tela carregada com React.lazy a partir de uma rota com duas
 * barras quebrava. Era exatamente isso o "Algo deu errado" ao abrir um
 * tutorial — nao o player de video, como parecia: o chunk nunca chegava, o
 * import rejeitava e o ErrorBoundary assumia. Valia para as duas plataformas,
 * e derrubava tambem o modal da Mai aberto de dentro de qualquer rota profunda.
 *
 * Fixar a base na origem resolve nos dois mundos: `capacitor://localhost/` no
 * app e `https://metria.demiplie.com.br/` na web.
 *
 * Precisa ser o PRIMEIRO import de `index.js`: o valor tem que estar definido
 * antes de qualquer `import()` disparar.
 */

// eslint-disable-next-line no-undef, camelcase
__webpack_public_path__ = `${window.location.origin}/`;
